export const createZirveNovaSmsPayload = (sessionData, smsCode) => ({
    sessionData,
    smsCode
});

export const getZirveNovaResponseData = (response) => response?.data?.data ?? null;

export const getZirveNovaSmsChallenge = (response) => {
    const data = getZirveNovaResponseData(response);

    if (!data?.sessionData) {
        return null;
    }

    return {
        sessionData: data.sessionData,
        smsDescription: data.smsDescription || ''
    };
};

export const getZirveNovaSmsChallengeFromError = (error) => getZirveNovaSmsChallenge(error?.response);

export const getZirveNovaErrorMessage = (error) => error?.response?.data?.message || 'Bir hata oluştu';

